export const useGetColorShield = (shield: string) => {
  if (shield === 'blue') {
    return 'primary'
  } else if (shield === 'green') {
    return 'secondary'
  } else {
    return 'grey-4'
  }
}